import {Injectable} from '@angular/core';
import {Resolve, Router, ActivatedRoute} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '../_services/notification.service';
import { AuthService } from '../_services/auth.service';

@Injectable()
export class PassTokenResolver {
    model: any = {};
    constructor(private authService: AuthService, private router: Router,
        private notify: NotificationService) {}

    resolve( route: ActivatedRoute) {
        this.model.token = route.queryParams['token'];
        return this.authService.checkToken(this.model).pipe(
            catchError(error => {
                this.notify.error('Zahtev za izmenu vise nije validan, posaljite novi');
                this.router.navigate(['/login']);
                return of(null);
            })
        );
    }
}
